import { useContent } from "@/content/ContentProvider";
import React from "react";
import PageHero from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import { PillButton } from "@/components/site/Kit";
import ShaderBackground from "@/components/site/ShaderBackground";
import WorkflowDiagram from "@/components/site/WorkflowDiagram";
import { Check } from "lucide-react";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
export default function Services() {
  const { text: cmsText, SERVICES, STATIC: siteStatic } = useContent();
  const FAQ = siteStatic["Services"].FAQ;
  return (
    <>
      <PageHero
        label={cmsText("Services.Services.services.5cbd58")}
        title={cmsText("Services.Services.understand-build-prove-.4b9a33")}
        text={cmsText(
          "Services.Services.one-workflow-connected-to-the-tools-around-it.1874b6",
        )}
      />
      <section className="px-5 pt-16 lg:pt-28">
        <div className="mx-auto flex max-w-[1400px] flex-col gap-24">
          {SERVICES.map((s, i) => (
            <div
              key={s.slug}
              id={s.slug}
              data-testid={`service-${s.slug}`}
              className="grid scroll-mt-24 gap-8 lg:grid-cols-12"
            >
              <Reveal
                className={`min-h-[360px] overflow-hidden rounded-[24px] lg:col-span-5 ${i % 2 ? "lg:order-2 lg:col-start-8" : ""}`}
              >
                <WorkflowDiagram steps={s.steps} />
              </Reveal>
              <Reveal
                className={`flex flex-col justify-center lg:col-span-6 ${i % 2 ? "lg:col-start-1 lg:row-start-1" : "lg:col-start-7"}`}
              >
                <span className="text-[12px] opacity-40">{s.n}</span>
                <h2 className="nm-title mt-2 text-[44px] leading-none sm:text-[72px]">
                  {s.title}
                </h2>
                <p className="mt-4 text-[22px] leading-[1.15] tracking-[-0.02em]">
                  {s.short}
                </p>
                <p className="mt-4 max-w-[520px] text-[16px] leading-[1.4] opacity-60">
                  {s.body}
                </p>
                <ul className="mt-8 space-y-2">
                  {s.points.map((p) => (
                    <li
                      key={p}
                      className="flex items-start gap-3 rounded-[20px] bg-[#f7f7f7] px-5 py-3 text-[14px]"
                    >
                      <Check size={14} className="mt-1 shrink-0" />
                      {p}
                    </li>
                  ))}
                </ul>
              </Reveal>
            </div>
          ))}
        </div>
      </section>
      <section className="px-5 pt-28 lg:pt-44">
        <div className="mx-auto grid max-w-[1400px] gap-10 lg:grid-cols-12">
          <h2 className="nm-title text-[34px] leading-[1.03] sm:text-[52px] lg:col-span-5">
            {cmsText("Services.Services.before-we-start-.fc14ae")}
          </h2>
          <Accordion
            type="single"
            collapsible
            defaultValue="i0"
            className="lg:col-span-6 lg:col-start-7"
            data-testid="faq"
          >
            {FAQ.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`i${i}`}
                className="border-black/10"
              >
                <AccordionTrigger className="text-left text-[20px] font-normal tracking-[-0.02em] hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[16px] leading-[1.4] opacity-70">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
        <div className="relative mx-auto mt-24 max-w-[1400px] overflow-hidden rounded-[28px] bg-black p-8 text-white sm:p-14">
          <ShaderBackground dark strength={0.42} lines={12} fadeLeft={0.4} />
          <div className="relative z-10">
            <p className="nm-title max-w-[760px] text-[30px] leading-[1.05] sm:text-[52px]">
              {cmsText(
                "Services.Services.start-with-the-job-that-keeps-getting-stuck-.81478e",
              )}
            </p>
            <div className="mt-8">
              <PillButton to="/contact" variant="inverse" size="lg">
                {cmsText("Services.Services.discuss-your-workflow.184fa5")}
              </PillButton>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
